var _excluded = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { faInfoCircle, faBell, faBars, faSkullCrossbones } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { forwardRef, omitThemingProps, StylesProvider, tqc, useMultiStyleConfig, useStyles } from '../../system';
import { cx } from '../../utils';
var FAIcon = tqc(FontAwesomeIcon);
/**
 * Notification is used to draw attention to a component where there is action to be taken
 */
export var Notification = forwardRef((props, ref) => {
  var _omitThemingProps = omitThemingProps(props),
    {
      className
    } = _omitThemingProps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var styles = useMultiStyleConfig('Notification', _objectSpread({}, props));
  var notificationStyles = {
    position: 'relative',
    width: '30px'
  };
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(tqc.div, _extends({
    role: "notification",
    ref: ref
  }, rest, {
    className: cx('tqc-notification', className),
    __css: notificationStyles
  })));
});
export var NotificationBadge = forwardRef((props, ref) => {
  var {
    className
  } = props;
  var defaultBadgeStyles = {
    borderRadius: '50%',
    bg: 'red',
    color: 'white',
    lineHeight: '1rem',
    fontSize: '0.4375rem',
    position: 'absolute',
    top: '-0.4375rem',
    left: '-0.3125rem',
    width: '16px',
    height: '16px',
    textAlign: 'center',
    outlineStyle: 'solid',
    outlineWidth: '0.0625rem'
  };
  return /*#__PURE__*/React.createElement(tqc.span, _extends({
    ref: ref
  }, props, {
    className: cx('tqc-notification__badge', className),
    __css: defaultBadgeStyles
  }));
});
NotificationBadge.displayName = 'NotificationBadge';
export var NotificationIcon = props => {
  var {
    iconName = 'bell',
    icon,
    className
  } = props;
  var presetIcons = {
    'bell': faBell,
    'bars': faBars,
    'infoCircle': faInfoCircle
  };
  var selectedIcon = icon || presetIcons[iconName];
  if (!selectedIcon) {
    selectedIcon = faSkullCrossbones;
  }
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.span, _extends({
    display: "inherit"
  }, props, {
    className: cx('tqc-notification__icon', className),
    __css: styles.icon
  }), /*#__PURE__*/React.createElement(FAIcon, {
    icon: selectedIcon,
    sx: {
      width: '100% !important',
      height: '100%'
    }
  }));
};
NotificationIcon.displayName = 'NotificationIcon';